import { useTranslation } from "react-i18next";
import { useConfigurationHistory } from "@/api/hooks";
import { Button } from "@/components/ui/Button";
export function ConfigurationHistory({
  resource,
  id,
  enabled = true,
}: {
  resource: "settings" | "company";
  id?: string;
  enabled?: boolean;
}) {
  const { t, i18n } = useTranslation();
  const query = useConfigurationHistory(resource, id, enabled);
  if (!enabled) return null;
  return (
    <details className="mt-4 rounded-md border border-line bg-surface p-4">
      <summary className="cursor-pointer text-sm font-medium">
        {t("settingsWorkspace.history")}
      </summary>
      <p className="mt-2 text-xs text-ink-faint">
        {t("settingsWorkspace.historyHint")}
      </p>
      {query.isLoading ? (
        <p>{t("common.loading")}</p>
      ) : query.error ? (
        <div role="alert">
          {t("settingsWorkspace.historyError")}
          <Button variant="ghost" size="sm" onClick={() => query.refetch()}>
            {t("common.retry")}
          </Button>
        </div>
      ) : !query.data?.length ? (
        <p className="mt-2 text-xs">{t("settingsWorkspace.noHistory")}</p>
      ) : (
        <ul className="mt-2 divide-y divide-line">
          {query.data.map((e) => (
            <li key={e.id} className="py-2 text-xs">
              <div className="flex flex-wrap justify-between gap-2">
                <span>
                  {t(`settingsWorkspace.action_${e.action}`)} ·{" "}
                  {e.actorName || t("settingsWorkspace.system")}
                </span>
                <time className="font-mono tabular text-ink-faint">
                  {new Date(e.createdAt).toLocaleString(i18n.language)}
                </time>
              </div>
              {e.fields && (
                <p className="mt-1 text-ink-soft">
                  {e.fields
                    .split(",")
                    .map((f) => t(`settingsWorkspace.field_${f}`))
                    .join(" · ")}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </details>
  );
}
